import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Bulk delete OrderSteps by their ID.
 *
 * @private
 */
export const deleteOrderSteps = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/delete', async (orderStepIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/order/deleteSteps', {
      category: 'rpc',
      type: 'rpc/order/deleteSteps',
      orderStepIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deleteOrderSteps}`,
      { tags: ['rpc', 'order'], info: orderStepIds },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Deleting ${orderStepIds.join(' ,')} Failed`,
      error,
    })
  }
})
